<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('Price.FullContainerAddonFreightDetails')"
    width="340px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="details-view fcl-addon-form"
  >
    <div class="main-content">
      <div style="margin-bottom: 10px">
        <el-button no="onSubmit" type="primary" @click="onSubmit">{{ $t('Pricing.Save') }}</el-button>
        <el-button no="onCancel" @click="onCancel">{{ $t('Pricing.Cancel') }}</el-button>
      </div>
      <div style="width: fit-content">
        <div style="display: flex">
          <div class="section form-column">
            <el-form
              :disabled="readonly"
              label-width="100px"
              label-position="left"
            >
              <el-form-item ref="pol" :label="$t('Pricing.POL')">
                <cargo-advance-select
                  no="pol"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  :default-value="price.pol"
                  filterable
                  @parentCallBack="p=>{price.pol=p.value}"
                />
              </el-form-item>
              <el-form-item ref="pod" :label="$t('Pricing.POD')">
                <cargo-advance-select
                  no="pod"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  :default-value="price.pod"
                  filterable
                  @parentCallBack="p=>{price.pod=p.value}"
                />
              </el-form-item>
              <el-form-item ref="eqType" :label="$t('Pricing.EqType')">
                <cargo-advance-select
                  no="eqType"
                  :select-type="selectTypeNames.basic_data_EQType"
                  tag-name="code"
                  :clearable="false"
                  :default-value="price.eqType"
                  @parentCallBack="p=>{price.eqType=p.value}"
                />
              </el-form-item>
              <el-form-item ref="currency" :label="$t('Pricing.Currency')">
                <cargo-advance-select
                  no="currency"
                  :select-type="selectTypeNames.basic_data_Currency"
                  :clearable="false"
                  :default-value="price.currency"
                  @parentCallBack="p=>{price.currency=p.value}"
                />
              </el-form-item>
              <el-form-item label="20'">
                <numeric-stepper
                  no="sum20"
                  :show-tact="false"
                  :show-value="price.sum20"
                  @onChangeValue="p=>{price.sum20=p}"
                />
              </el-form-item>
              <el-form-item label="40'">
                <numeric-stepper
                  no="sum40"
                  :show-tact="false"
                  :show-value="price.sum40"
                  @onChangeValue="p=>{price.sum40=p}"
                />
              </el-form-item>
              <el-form-item label="40HC'">
                <numeric-stepper
                  no="sumhc"
                  :show-tact="false"
                  :show-value="price.sumhc"
                  @onChangeValue="p=>{price.sumhc=p}"
                />
              </el-form-item>
              <el-form-item label="45'">
                <numeric-stepper
                  no="sum45"
                  :show-tact="false"
                  :show-value="price.sum45"
                  @onChangeValue="p=>{price.sum45=p}"
                />
              </el-form-item>
              <el-form-item ref="carrier" :label="$t('Pricing.Carrier')">
                <cargo-advance-select
                  no="carrier"
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{seaCmp:true}"
                  :custom-label="(item)=>`[${item.shortName}]${item.chineseName}`"
                  :show-custom-label-in-option="true"
                  :default-value="price.carrier"
                  @parentCallBack="p=>{price.carrier=p.cmpIdx}"
                />
              </el-form-item>
              <el-form-item ref="shippingLine" :label="$t('Pricing.ShippingLine')">
                <el-input
                  v-model="price.shippingLine"
                  no="shippingLine"
                  :maxlength="16"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.DaysUnitSea')">
                <el-input-number
                  v-model="price.days"
                  no="days"
                  :min="0"
                  style="width: 100%"
                  :max="999999999"
                />
              </el-form-item>
              <el-form-item ref="priceDateType" :label="$t('Pricing.PriceDateType')">
                <el-select
                  v-model="price.priceDateType"
                  no="priceDateType"
                >
                  <el-option
                    v-for="(item,index) in priceDateTypes"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item ref="beginDate" :label="$t('Pricing.BeginDate')">
                <div style="display: flex">
                  <el-date-picker
                    v-model="price.beginDate"
                    no="beginDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="flex: 1;"
                    clearable
                  />
                </div>
              </el-form-item>
              <el-form-item ref="endDate" :label="$t('Pricing.EndDate')">
                <div style="display: flex">
                  <el-date-picker
                    v-model="price.endDate"
                    no="endDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="flex: 1;"
                    clearable
                  />
                </div>
              </el-form-item>
              <el-form-item :label="$t('Pricing.Remarks')">
                <el-input
                  v-model="price.remarks"
                  no="remarks"
                  type="textarea"
                  :maxlength="255"
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import StrUtils from '@/utils/StrUtils'
import { savePriceFclAddon } from '@/api/price/priceFclAddon'
import { getLoading } from '@/utils/utilBaseElement'
import NumericStepper from '@/views/cargo/v0/Price/components/numericStepper'

export default {
  name: 'FclAddonForm',
  components: { NumericStepper, CargoAgGrid, cargoAdvanceSelect },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    readonly: {
      type: Boolean,
      default: () => false
    },
    isNew: {
      type: Boolean,
      default: () => false
    },
    price: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      fullscreenLoading: null,
      priceDateTypes: [
        {
          label: this.$t('Pricing.M'),
          value: 'M'
        },
        {
          label: this.$t('Pricing.F'),
          value: 'F'
        }]
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  methods: {
    onSubmit() {
      if (this.verifyForm()) {
        return
      }
      if (this.verifySame('pol', 'pod')) {
        return
      }
      if (this.price.beginDate > this.price.endDate) {
        this.$message.warning(this.$t('Pricing.CompareValidate'))
        return
      }
      this.price.modifiedBy = this.$store.getters.userId
      this.price.dateModified = new Date()
      this.save()
    },
    save() {
      this.fullscreenLoading = getLoading()
      let changeState = false
      if (!this.isNew && this.price.state === 1) {
        this.price.state = 0
        changeState = true
      }
      savePriceFclAddon(this.price).then((res) => {
        this.fullscreenLoading.close()
        if (res.data) {
          if (!changeState) {
            this.$message.success(this.$t('Pricing.SavedSucceed'))
          } else {
            this.$message.success(this.$t('Pricing.CurrentPriceEditSucceed'))
          }
          this.$emit('reload')
        } else {
          this.$message.success(this.$t('Message.SaveFailed'))
        }
        this.$emit('close')
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    verifyForm() {
      for (const ref in this.$refs) {
        if (this.verifyField(ref)) {
          const label = this.$refs[ref].label
          this.$message.warning(label + this.$t('Pricing.WrongInput'))
          return true
        }
      }
    },
    verifyField(field) {
      if (typeof this.price[field] === 'number') {
        return this.price[field] === 0
      }
      return StrUtils.isEmpty(this.price[field])
    },
    onCancel() {
      this.$emit('close')
    },
    verifySame(field1, field2) {
      if (this.price[field1] === this.price[field2]) {
        const label1 = this.$refs[field1].label
        const label2 = this.$refs[field2].label
        const message = this.$t('Pricing.MustDifferent')
        this.$message.warning(message.replace('{0}', label1).replace('{1}', label2))
        return true
      }
      return false
    }
  }
}
</script>

<style lang="scss">
  @import "~@/styles/element-variables.scss";
  .fcl-addon-form{
    .el-textarea__inner{
      min-height: 100px !important;
    }
    .form-operator{
      margin-left: 5px;
      cursor: pointer;
      font-size: 18px;
      .el-icon-circle-plus{
        color: $--color-success;
      }
      .el-icon-remove
      {
        color: $--color-danger;
      }
    }
  }
</style>
